import Client from '~/types/api/api-module';
import ApiOptions from '../../api-options';

const BASE_URL = `${process.env.API_V4_HOST}/_exclusive/mitra-qr`;

export default Client.wrap({
  getQrisCode() {
    return this.get(`${BASE_URL}/qris`, 'user', new ApiOptions());
  },
});
